/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { PrismSelectInput } from '@mylighthouse/prism-ember';
import HotelStrategyChartsChartRoomtypePatternDetail from 'lumen/components/hotel/strategy/charts/chart-roomtype-pattern-detail';
import { SUBTYPE_VALUES_KEY_PATTERN } from 'lumen/utils/constants/rate-strategy-constants';

const CHART_MARGIN_TOP = 16;
const SELECTED_ROOMTYPE_DROPDOWN_HEIGHT = 40;

interface HotelStrategyRoomtypeTabsTabGraphSignature {
  Args: {
    params: unknown;
  };
}

export default class HotelStrategyRoomtypeTabsTabGraph extends Component<HotelStrategyRoomtypeTabsTabGraphSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get correctedChartHeight() {
    return (
      // @ts-expect-error: Incorrect type
      this.args.params.height -
      CHART_MARGIN_TOP -
      SELECTED_ROOMTYPE_DROPDOWN_HEIGHT
    );
  }

  @computed('args.params.subtypes')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get roomtypeOptions() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.params?.subtypes.map((subtype) => {
      return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        id: subtype.id,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        label: subtype.formattedLabel[SUBTYPE_VALUES_KEY_PATTERN],
      };
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get roomtypeValue() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.roomtypeOptions.find(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (option) => option.id === this.args.params.selectedRoomtypeParam,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get selectedRoomtypeData() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.params.subtypes.find(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (subtype) => subtype.id === this.args.params.selectedRoomtypeParam,
    );
  }

  @action
  // @ts-expect-error: Incorrect type
  handleRoomtypeChange(roomtypeOption): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.params.updateSelectedRoomType(roomtypeOption.id);
  }

  <template>
    <div class="rate-strategy-roomtype-detail">
      <div
        class="rate-strategy-roomtype-detail__graph-subtype-selection-container flex flex-row items-center justify-between"
      >
        <PrismSelectInput
          @isSmall={{true}}
          @onChange={{this.handleRoomtypeChange}}
          @options={{this.roomtypeOptions}}
          @value={{this.roomtypeValue}}
        />

      </div>

      <div class="rate-strategy-roomtype-detail__graph-container mt-400">
        <HotelStrategyChartsChartRoomtypePatternDetail
          @containerHeight={{this.correctedChartHeight}}
          {{! @glint-expect-error: Incorrect type }}
          @data={{@params.parentController.typesDataPerId.roomtype}}
          @selectedRoomtypeData={{this.selectedRoomtypeData}}
        />
      </div>
    </div>
  </template>
}
